import { Injectable } from 'angular-ts-decorators';

import { Observable } from 'rxjs';
import {
  withLatestFrom,
  startWith,
  filter,
  map as mapStream,
} from 'rxjs/operators';

import { CookieStreams } from '@shared/app/scripts/services/cookie-streams';
import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { Domain } from '@shared/app/scripts/services/domain';
import { Session } from '@shared/app/scripts/services/session';

/**
 * TODO document the service
 */
@Injectable('sidAutoRedirect')
export class SidAutoRedirect {
  constructor(
    protected cookieStreams: CookieStreams,
    protected currentSession: CurrentSession,
    protected domain: Domain,
    protected session: Session,
  ) {
    'ngInject';
  }

  unexpectedTenantIdChanges$: Observable<any>;
  unexpectedSidChanges$: Observable<any>;

  init() {
    const observedTenantId$: Observable<string> = this.cookieStreams
        .getChange$('tenantId')
        .pipe(
          mapStream((value) => {
            if (angular.isDefined(value)) {
              return String(value);
            }
            return value;
          }),
        ),
      expectedSid$: Observable<string> = this.currentSession.sid$.pipe(
        startWith(this.currentSession.sid),
      );

    this.unexpectedTenantIdChanges$ = observedTenantId$.pipe(
      withLatestFrom(this.currentSession.tenantId$),
      filter((values) => values[0] !== values[1]),
      mapStream((values) => {
        return { expected: values[1], observed: values[0] };
      }),
    );

    this.unexpectedSidChanges$ = this.cookieStreams.getChange$('sid').pipe(
      withLatestFrom(expectedSid$),
      filter((values) => values[0] !== values[1]),
      mapStream((values) => {
        return { expected: values[1], observed: values[0] };
      }),
    );
  }
}
